import styled from '@emotion/styled'
import type { Theme } from '@yuno/design-system-web'

const PageTitle = styled.span<{ children: string; theme?: Theme }>`
  color: ${({ theme }) => theme.palette.neutral.black};
  font-weight: ${({ theme }) => theme.typography.xl.regular.fontWeight};
  font-size: ${({ theme }) => theme.typography.xl.regular.fontSize};
  font-family: ${({ theme }) => theme.typography.xl.regular.fontFamily};
`

export default PageTitle
